/**
 * One control height for the whole panel.
 *
 * Inputs, selects, buttons, date pickers and segmented controls all stand
 * 35px tall, everywhere. Before this the panel ran on Ant Design's default of
 * 32 and then reached for `height: 40px !important` whenever a row of controls
 * looked wrong — there are a dozen such rules in index.css, each covering one
 * component on one screen. Anything not yet patched stayed 32, which is why a
 * search box and the segmented control beside it never quite lined up.
 *
 * Setting the token instead fixes it at the source: antd sizes every control
 * from `controlHeight`, so one value does what twelve CSS overrides were
 * trying to do. The overrides can stay — they already say 40 — but nothing new
 * needs to be added, and a component nobody thought about is right by default.
 *
 * `controlHeightLG` is pinned to the same number ON PURPOSE. antd derives it
 * as controlHeight + 8, so leaving it alone would make every `size="large"`
 * button 48px and reintroduce exactly the mismatch this removes.
 *
 * `controlHeightSM` is deliberately NOT pinned. It derives from this value, and the
 * places that ask for a small control — the switches and link buttons inside
 * dense tables — want to stay small. Forcing those to 40 would add a
 * centimetre to every row of a 5,000-book table.
 */
export const CONTROL_HEIGHT = 35;

export const controlTokens = {
  controlHeight: CONTROL_HEIGHT,
  controlHeightLG: CONTROL_HEIGHT,
};
